// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__7MKRP","primary":"Button_primary__3rjcG","info":"Button_info__3hY3F","outline":"Button_outline__emMQc"};